import { useState } from 'react';
import { FetchState } from 'src/reducers/fetchReducer';
import { editProductSegment, EditProductSegmentData } from '../../api/productAlerts.api';

type FieldChangeState = FetchState<unknown>;

type SetProductSegmentField = (data: EditProductSegmentData, onSuccess: () => void) => Promise<unknown>;

const initialState: FieldChangeState = {
  loading: false,
  error: null,
  data: null,
};

const useProductSegmentFieldChange = (): [FieldChangeState, SetProductSegmentField] => {
  const [state, setState] = useState<FieldChangeState>(initialState);

  const mergeState = (state: Partial<FieldChangeState>) => {
    setState((prev: FieldChangeState) => ({ ...prev, ...state }));
  };

  const setProductSegmentField = async (postData: EditProductSegmentData, onSuccess: () => void) => {
    mergeState({ loading: true, error: null });
    try {
      const response = await editProductSegment(postData);
      mergeState({ loading: false, error: null, data: response });
      onSuccess();
    } catch (e) {
      mergeState({ loading: false, error: e, data: null });
    }
  };

  return [state, setProductSegmentField];
};

export default useProductSegmentFieldChange;
